import Rotation from '../../Rotation/web/store';

//List of store.js files for web
export default {
	Rotation,
};
